import React, { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import CustomTab from '../../../Common/customComponents/CustomTab';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader';
import { BasicModalV2, TextButton } from '../../../../components';
import Form01ColdDetail from '../component/Form01ColdDetail.tsx';
import Form02HotDetail from '../component/Form02HotDetail.tsx';

import '../../../../assets/scss/preview.css';
import PermitIssuePreview from '../component/PermitIssuePreview.tsx';
import { ptwApi } from '../../../../api/ptw.api.ts';
import { commonMsg } from '../../../../utils/globalUtil.tsx';
import { useAsync, useUser } from '../../../../hooks';
import Form03SpaceDetail from '../component/Form03SpaceDetail.tsx';
import Form04RoadDetail from '../component/Form04RoadDetail.tsx';
import Form05LiftingDetail from '../component/Form05LiftingDetail.tsx';
import Form06ExcavationDetail from '../component/Form06ExcavationDetail.tsx';
import { getPermitIssueLabel } from '../index.tsx';
import { useReactToPrint } from 'react-to-print';
import { safObjectHelper } from '../../../../utils/SafObjectHelper.ts';
import PermitCancel from './PermitCancelModal.tsx';
import { useSetRecoilState } from 'recoil';
import { LoadingAtom } from '../../../../modules';
import FileUploaderModal from './FileUploaderModal.tsx';
import PermitExtendModal from './PermitExtendModal.tsx';
import _ from 'lodash';
import { PtwDetailModalProvider, usePtwDetailModal } from '../../contexts/PtwDetailModalContext.ts';
import { useStatusUpdateDate } from '../../contexts/PermitStatusUpdateDate.ts';
import { usePermitIssue } from '../../contexts/PermitIssueContext.ts';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  title: string;
  permitIssueList: any;
  setPermitIssueList: any;
  detailData: any;
  setDetailData: any;
  onActionCallback?: any;
  isPermitIssueTypeModalOpen: any;
  setIsPermitIssueTypeModalOpen: any;
  isReadOnly: boolean;
  isSelectFormCode?: boolean;
}
interface UploadFile {
  fileId: string;
  fileOriginalname: string;
  file: File;
  progress: number;
  size: number;
  isNewFile?: boolean;
}
const PermitIssueDetailModal = (props: IProps) => {
  const { statusUpdateDate, setStatusUpdateDate } = useStatusUpdateDate();
  const {
    setSelectedApprovalType,
    setAutoOpenSignatureType,
    selectedApprovalType,
    saveBeforeApproval
  } = usePtwDetailModal();
  const { pageId } = usePermitIssue();
  const isApprovalMode = pageId === 'approval';
  const { callAsync, showAlarm, closeAlarm } = useAsync();
  const [activeTab, setActiveTab] = useState<string>(props.permitIssueList[0]);
  const [tabList, setTabList] = useState<any>([]);
  const [enablePreview, setEnablePreview] = useState<boolean>(false);
  const user = useUser();
  const setLoading = useSetRecoilState(LoadingAtom);
  const [data, setData] = useState<any>({
    CW: {},
    HW: {},
    SW: {},
    RC: {},
    EC: {},
    LP: {}
  });

  const [isPermitCancelModalOpen, setIsPermitCancelModalOpen] = useState<boolean>(false);
  const [isFileUploaderModalOpen, setIsFileUploaderModalOpen] = useState<boolean>(false);
  const [isPermitExtendModal, setIsPermitExtendModal] = useState<boolean>(false);
  const originData = useRef<any>(null);
  const IGNORE_KEYS = new Set([
    'receiverNm',
    'validStartTime',
    'validEndTime',
    'approvalMVOList',
    'permitDate',
    'workRisk'
  ]);

  useEffect(() => {
    //console.log('props.detailData.finish', props.detailData.finish);
  }, [props.detailData]);

  const isEqualValue = (a: any, b: any) => {
    if (typeof a === 'boolean' || typeof b === 'boolean') {
      if (!b) b = false;
      return a === b;
    }

    if (typeof a === 'object' && typeof b === 'object') {
      return _.isEqual(a, b);
    }

    return String(a ?? null) === String(b ?? null);
  };

  const isEditing = useMemo(() => {
    if (!props.isModalOpen) return false;

    const init = originData.current;
    if (!init) return false;

    const tabs = ['CW', 'HW', 'SW', 'RC', 'EC', 'LP'];

    return tabs.some((tab) => {
      const tabData = data[tab] ?? {};
      const initTab = init[tab] ?? {};

      return Object.keys(tabData).some((key) => {
        if (IGNORE_KEYS.has(key)) return false;
        return !isEqualValue(tabData[key], initTab[key]);
      });
    });
  }, [data, props.isModalOpen]);

  const modalClose = () => {
    //alert(data?.status);
    if (isEditing) {
      if (data?.status == null || data?.status == 'DRAFT') {
        var isCancel = true;
        var list = data.ptwPageDVOList;
        for (var i in list) {
          if (list[i].approvalStatus !== 'CANCEL') {
            isCancel = false;
          }
        }
        console.log(data);
        if (isCancel === true) {
          props.setIsModalOpen(false);
        } else {
          commonMsg.confirm(
            showAlarm,
            closeAlarm,
            'Confirm',
            'There are unsaved changes. Do you want to close?',
            () => {
              props.setIsModalOpen(false);
            }
          );
        }
      } else {
        props.setIsModalOpen(false);
      }
    } else {
      props.setIsModalOpen(false);
    }
  };

  useEffect(() => {
    loadTabs(props.permitIssueList);
  }, [props.permitIssueList]);

  useEffect(() => {
    if (!props.isModalOpen) return;
    if (originData.current) return;

    const isDataReady = Object.values(data).some((tab: any) => {
      return tab && Object.keys(tab).length > 0;
    });

    if (!isDataReady) return;

    originData.current = _.cloneDeep(data);
  }, [data, props.isModalOpen]);

  useEffect(() => {
    if (props.isModalOpen) {
      setData({
        CW: { workRisk: 'GENERAL' },
        HW: { workRisk: 'GENERAL' },
        SW: { workRisk: 'HIGH' },
        RC: { workRisk: 'GENERAL' },
        EC: { workRisk: 'HIGH' },
        LP: { workRisk: 'HIGH' }
      });

      if (props.detailData?.ptwDSeq) {
        /*기존값 있을때 */
        loadData(props.detailData?.ptwDSeq);
      } else {
        /*기존값 없을때 */
        loadTabs(props.permitIssueList);
      }
    } else {
      /*창 닫기시 데이터 초기화*/
      props.setDetailData({});
      setData({});
      setTabList([]);
      setActiveTab('');
      setEnablePreview(false);
      originData.current = null;
    }
  }, [props.isModalOpen]);

  useEffect(() => {
    if (!activeTab) return;
    setData((prev: any) => {
      const next = { ...prev };
      next[activeTab] = {
        ...next[activeTab]
      };
      return next;
    });
  }, [activeTab]);

  const loadData = (ptwDSeq: number) => {
    setLoading(true);
    ptwApi
      .getPtwIssueInfo({ ptwDSeq: ptwDSeq, isApprovalComplete: props.detailData.finish })
      .then((r) => {
        setLoading(false);
        setData(r.resultObject);
        if (r.resultObject?.ptwPageDVOList?.length > 0) {
          const tempData: any = {};
          const tempSheetList: any[] = [];
          r.resultObject.ptwPageDVOList.forEach((item: any, index: number) => {
            const code = item.formCode; // 'CW', 'HW', ...
            tempData[code] = {
              ...item,
              fileList: item.fileList || [],
              newFileList: item.newFileList || []
            };
            tempSheetList.push(code);
          });

          setData((prev: any) => ({
            ...prev,
            ...tempData
          }));
          props.setPermitIssueList(tempSheetList); //addSheet 세팅

          loadTabs(tempSheetList);
        } else {
          commonMsg.alert(showAlarm, closeAlarm, 'ERROR', 'error getPtwIssueInfo', null);
        }
      });
  };

  const loadTabs = (codes: string[]) => {
    const list = Array.isArray(codes) ? codes.filter(Boolean) : [];
    const priority = new Set(['EC', 'LP']);

    const priorityList = list.filter((code: string) => priority.has(code));
    const normalList = list.filter((code: string) => !priority.has(code));

    const ordered = [...priorityList, ...normalList];

    const tempTabList = ordered?.map((code: string, index: number) => ({
      label: `${index + 1}. ${getPermitIssueLabel(code)}`,
      value: code
    }));

    const normalized = normalizeTabList(tempTabList);
    setTabList(normalized);

    if (props.isSelectFormCode) {
      setActiveTab(props.detailData.formCode);
    } else {
      setActiveTab(normalized[0]?.value ?? '');
    }
  };

  const handleChange = (e: any) => {
    const { name, value, safDataType } = e.target;
    const key = activeTab;
    if (safDataType === 'saf-form-data') {
      setData((prev: any) => ({
        ...prev,
        [key]: {
          ...prev[key],
          formData: {
            ...(prev[key]?.formData || {}),
            [name]: value
          }
        }
      }));
    } else {
      setData((prev: any) => ({
        ...prev,
        [key]: {
          ...prev[key],
          [name]: value || null
        }
      }));
    }
  };
  const fieldLabelMap: Record<string, string> = {
    companyId: 'Company',
    jhaNo: 'Job Hazard Analysis No.',
    statementNo: 'Job Method Statement No.',
    location: 'Work Location/Area',
    locationText: 'Work Location/Area',
    disciplineCd: 'Discipline',
    workCd: 'Detail 1',
    validStartTime: 'Expected Work Duration',
    validEndTime: 'Expected Work Duration',
    description: 'Job Description',
    subcontractor: 'Sub Contractor',
    manPower: 'Manpower Planning'
  };
  const save = (
    saveType: 'T' | 'S',
    approvalSaveYn = false,
    resolveApproval?: (success: boolean) => void
  ) => {
    const requiredMap: Record<string, { base: readonly string[]; submit: readonly any[] }> = {
      CW: {
        base: ['companyId'],
        submit: [
          'companyId',
          /*'jhaNo',*/
          /*'statementNo',*/
          'location',
          'locationText',
          'disciplineCd',
          'workCd',
          'validStartTime',
          'validEndTime',
          { key: 'manPower', subKey: 'manPower1' },
          'description'
        ]
      },
      HW: {
        base: ['companyId'],
        submit: [
          'companyId',
          /*'jhaNo',*/
          /*'statementNo',*/
          'location',
          'locationText',
          'disciplineCd',
          'workCd',
          'validStartTime',
          'validEndTime',
          { key: 'manPower', subKey: 'manPower1' },
          'description'
        ]
      },
      SW: {
        base: [],
        submit: [
          'companyId',
          /*'jhaNo',*/
          /*'statementNo',*/
          'location',
          'locationText',
          'disciplineCd',
          'workCd',
          'manPower',
          { key: 'manPower', subKey: 'manPower1' },
          'description'
        ]
      },
      RC: {
        base: [],
        submit: [
          'location',
          'locationText',
          'subcontractor',
          'companyId',
          'validStartTime',
          'validEndTime'
        ]
      },
      EC: { base: [], submit: ['location', 'locationText', 'subcontractor', 'companyId'] },
      LP: { base: [], submit: ['location', 'locationText', 'companyId'] }
    };

    const isFilled = (v: any): boolean => {
      if (v === null || v === undefined) return false;
      if (typeof v === 'string') return v.trim().length > 0;
      // array
      if (Array.isArray(v)) {
        if (v.length === 0) return false;

        return v.some((item: any) => {
          if (item === null || item === undefined) return false;

          if (typeof item === 'string') {
            return item.trim().length > 0;
          }

          if (typeof item === 'object') {
            return Object.values(item).some((val) => isFilled(val));
          }

          return true;
        });
      }
      return true;
    };

    let check = true;
    let fileCheck = true;
    let planningCheck = true;
    const fileTargetCode: string[] = ['CW', 'HW', 'SW'];
    const jobPlanningCode: string[] = ['CW', 'HW'];
    let missingField = null;
    for (const tab of tabList || []) {
      if (saveType === 'T') {
        break;
      }
      const code = String(tab?.value ?? '');
      if (!code) continue;

      const rule = requiredMap[code];
      const required = saveType === 'S' ? [...rule.base, ...rule.submit] : [...rule.base];

      const obj = data?.[code] ?? {};
      /*const ok = required.every((k) => isFilled(obj?.[k]));
      if (!ok) {
        setActiveTab(code); // 첫 누락 탭으로 이동
        check = false;
        break;
      }*/
      const hasSubKeyValue = (arr: any[], subKey: string): boolean => {
        if (!Array.isArray(arr) || arr.length === 0) return false;

        return arr.some((item) => {
          const value = item?.[subKey];
          return value !== null && value !== undefined && String(value).trim() !== '';
        });
      };
      const missing = required.filter((k) => {
        if (typeof k === 'string') {
          return !isFilled(obj?.[k]);
        }

        if (typeof k === 'object' && k.key && k.subKey) {
          const arr = obj?.[k.key];
          return !hasSubKeyValue(arr, k.subKey);
        }

        return false;
      });

      if (missing.length > 0) {
        console.group(`[VALIDATION FAIL] Tab: ${code}`);
        console.log('Missing fields:', missing);
        console.log('Current values:', obj);
        console.groupEnd();

        missingField = missing[0];
        setActiveTab(code);
        check = false;
        break;
      }
      if (
        fileTargetCode.includes(code) &&
        obj.workRisk == 'HIGH' &&
        (!obj.fileList || obj.fileList.length === 0)
      ) {
        setActiveTab(code);
        fileCheck = false;
        break;
      }
      if (
        jobPlanningCode.includes(code) &&
        obj.fileList &&
        obj.fileList.length > 0 &&
        !Object.entries(obj.formData ?? {}).some(([k, v]) => !k.endsWith('-REMARKS') && v === true)
      ) {
        setActiveTab(code);
        planningCheck = false;
        break;
      }
    }

    // input valid 체크
    if (!check) {
      let fieldKey: string | undefined;

      if (typeof missingField === 'string') {
        fieldKey = missingField;
      } else if (typeof missingField === 'object' && missingField !== null) {
        fieldKey = missingField.key;
      }

      const label =
        fieldKey === 'location' && activeTab === 'LP'
          ? 'Location / Unit No'
          : fieldLabelMap[fieldKey as string] || fieldKey;

      commonMsg.alert(showAlarm, closeAlarm, 'Warning', `Please enter the ${label}.`, null);

      return;
    }

    //승인목록 체크
    if (saveType == 'S') {
      const invalid = (tabList ?? []).some(
        (item: any) =>
          ['CW', 'HW', 'SW', 'RC'].includes(item.value) &&
          !hasAllApprovalTypesAt(data?.[item.value]?.approvalMVOList)
      );

      if (invalid) {
        commonMsg.alert(
          showAlarm,
          closeAlarm,
          'Warning',
          'Please check the APPROVAL section.',
          null
        );
        return;
      }
    }

    // workRisk 가 고위험일경우는 file upload 필수
    // if (!fileCheck) {
    //   commonMsg.alert(showAlarm, closeAlarm, 'Warning', 'Please upload the file.', null);
    //   return;
    // }

    if (!planningCheck) {
      commonMsg.alert(
        showAlarm,
        closeAlarm,
        'Warning',
        'Please select the Work / Job Planning section.',
        null
      );
      return;
    }

    //renew data 일 경우
    if (
      saveType == 'S' &&
      mainPermitData.refPtwDSeq &&
      mainPermitData.newFileList.length == 0 &&
      fileTargetCode.includes(mainPermitData?.formCode)
    ) {
      commonMsg.alert(
        showAlarm,
        closeAlarm,
        'Error',
        'Please attach the previous permit file ',
        null
      );
      return;
    }

    let message = 'Do you want to save temporarily?';
    if (saveType === 'S') {
      message = 'Do you want to save it?';
    }

    if (resolveApproval) {
      saveData(saveType, approvalSaveYn, resolveApproval);
    } else {
      commonMsg.confirm(showAlarm, closeAlarm, 'Confirm', message, () => {
        saveData(saveType, approvalSaveYn);
      });
    }
  };

  const saveData = (
    saveType: string,
    approvalSaveYn = false,
    resolveApproval?: (success: boolean) => void
  ) => {
    //console.log(data);
    setLoading(true);
    var clone = safObjectHelper.clone(data);
    const formData = new FormData();
    Object.entries(clone).forEach(([key, object]) => {
      if (object === null || object === undefined) return;
      Object.entries(object).forEach(([subKey, subObject]) => {
        if (subKey === 'fileList') {
          var fileList = subObject;
          for (var k in fileList) {
            const originalFile = fileList[k].file;
            if (originalFile) {
              const newFileName = fileList[k].fileId + '$$$' + originalFile.name;
              const modifiedFile = new File([originalFile], newFileName, {
                type: originalFile.type
              });
              formData.append('newFiles', modifiedFile);
            }
          }
        }
        if (subKey === 'newFileList') {
          var fileList = subObject;
          for (var k in fileList) {
            const originalFile = fileList[k].file;
            if (originalFile) {
              const newFileName = fileList[k].fileId + '$$$' + originalFile.name;
              const modifiedFile = new File([originalFile], newFileName, {
                type: originalFile.type
              });
              formData.append('refNewFiles', modifiedFile);
            }
          }
        }
        const skipKeys = ['approvalMVOList', 'fileList', 'newFileList', 'iotDeviceList'];
        if (skipKeys.includes(subKey)) return;
        if (safObjectHelper.isJsonObject(subObject)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          object[subKey] = JSON.stringify(subObject);
        }
      });
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    var saveData = [];
    tabList.forEach((item: any, i: number) => {
      const obj = clone?.[item.value] ?? {};
      obj.formCode = item.value;
      saveData.push(obj);
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    clone.ptwPageDVOList = saveData;
    clone.saveType = saveType;
    clone.approvalSaveYn = approvalSaveYn;
    formData.append(
      `param`,
      new Blob([JSON.stringify(clone)], {
        type: 'application/json'
      })
    );
    ptwApi.setPtwIssue(formData).then(async (r) => {
      setLoading(false);
      if (!r.isSuccess) {
        commonMsg.alert(showAlarm, closeAlarm, 'Error', 'Error', null);
        resolveApproval?.(false);
        return;
      } else {
        if (resolveApproval) {
          // 결재 전 저장 흐름: 모달 닫지 않고 데이터만 갱신 후 결재 진행
          if (data.ptwMSeq) {
            loadData(props.detailData?.ptwDSeq);
          }
          props.onActionCallback();
          resolveApproval(true);
        } else {
          if (data.ptwMSeq) {
            //기존데이터면 저장후 다시 불러옴
            loadData(props.detailData?.ptwDSeq);
          } else {
            //신규데이터면 저장후 무조건 창 닫아야함
            props.setIsModalOpen(false);
          }

          commonMsg.alert(showAlarm, closeAlarm, 'Success', 'It has been Saved.', () => {
            props.setIsModalOpen(false);
          });
          props.onActionCallback();
        }
      }
    });
  };

  const normalizeTabList = (list: any[]) => {
    const safe = Array.isArray(list) ? list : [];
    return safe?.map((t, idx) => {
      const code = String(t?.value ?? '');
      return {
        ...t,
        value: code,
        label: `${idx + 1}. ${getPermitIssueLabel(code)}`
      };
    });
  };

  const addSheet = () => {
    props.setIsPermitIssueTypeModalOpen(true);
  };

  /* Print */
  const previewRef = useRef(null);
  const [printPaperSize, setPrintPaperSize] = useState<'A4' | 'A3'>('A4');
  const [pendingPrint, setPendingPrint] = useState<boolean>(false);
  const printAction = useReactToPrint({
    contentRef: previewRef,
    documentTitle: 'SE&A Smart Safety Total Solution'
  });

  // printPaperSize 변경이 DOM(class)에 반영된 다음 렌더에서 실제 인쇄를 실행한다.
  useEffect(() => {
    if (!pendingPrint) return;
    printAction();
    setPendingPrint(false);
  }, [pendingPrint, printPaperSize]);

  const handlePrint = (paperSize: 'A4' | 'A3') => {
    commonMsg.confirm(
      showAlarm,
      closeAlarm,
      'Print',
      `In the print dialog, set Paper Size to "${paperSize}", Margins to "Default" and Scale to "Default" or "100%" for correct printing.`,
      () => {
        setPrintPaperSize(paperSize);
        setPendingPrint(true);
      }
    );
  };
  const setSubData = (formCode: string) => {
    return (updater: any) => {
      setData((prev: any) => {
        const prevTab = prev?.[formCode] ?? {};
        const nextTab = typeof updater === 'function' ? updater(prevTab) : updater;

        return {
          ...prev,
          [formCode]: nextTab
        };
      });
    };
  };

  //본인이 작성한 permit에 대해서만 cancel이 가능하다.
  const onCancel = () => {
    setIsPermitCancelModalOpen(true);
  };

  //활성화된 탭 기준으로 다른 탭의 항목들 복사
  const applyOther = () => {
    commonMsg.confirm(
      showAlarm,
      closeAlarm,
      'Confirm',
      'The contents of other tabs are copied based on the selected tab.',
      () => {
        const filtered = tabList.filter((tab: any) => tab?.value !== activeTab);

        setData((prev: any) => {
          const next = { ...prev };
          const source = prev[activeTab];

          filtered.forEach((item: any) => {
            const key = item?.value;
            if (!key) return;

            const prevWorkRisk = prev[key]?.workRisk ?? 'GENERAL';
            const prevPtwMSeq = prev[key]?.ptwMSeq ?? null;
            const prevPtwDSeq = prev[key]?.ptwDSeq ?? null;

            next[key] = {
              ...source,
              workRisk: prevWorkRisk,
              fileList: null,
              approvalMVOList: null,
              ptwMSeq: prevPtwMSeq,
              ptwDSeq: prevPtwDSeq
            };
          });

          return next;
        });
      }
    );
  };

  const tabXAction = (item: any) => {
    const mainPermits = ['CW', 'HW', 'SW', 'RC'];

    const mainCount = (tabList ?? []).filter((tab: any) => mainPermits.includes(tab.value)).length;

    if (mainCount <= 1 && mainPermits.includes(item.value)) {
      commonMsg.alert(
        showAlarm,
        closeAlarm,
        'Warning',
        'You must select at least one Main Permit.',
        null
      );
      return;
    }

    proceedTabClose(item);
  };

  const proceedTabClose = (item: any) => {
    const permitArray = ['CW', 'HW', 'SW', 'RC'];

    const filtered = (tabList || []).filter((tab: any) => tab?.value !== item?.value);

    const hasPermit = filtered.some((tab: any) => permitArray.includes(tab.value));
    if (!hasPermit) return;

    props.setPermitIssueList(
      props.permitIssueList.filter((issueItem: string) => issueItem !== item.value)
    );

    const nextTabList = normalizeTabList(filtered);

    setTabList(nextTabList);
    setActiveTab(nextTabList[0]?.value ?? '');
  };

  const hasAllApprovalTypesAt = (approvalMVOList?: any[]) => {
    if (!Array.isArray(approvalMVOList) || approvalMVOList.length === 0) return false;

    return approvalMVOList.every((row: any) => {
      // 오프라인이면 검사 제외(통과)
      if (row?.isOnline === false) return true;

      // 온라인이면 결재자 목록 있어야 통과
      return (row?.ptwPageApprovalDVOList?.length ?? 0) > 0;
    });
  };

  const setApprovalSave = () => {
    save('S', true);
  };

  function openFileUploader() {
    setIsFileUploaderModalOpen(true);
  }
  //작성자인지 판단
  const isCurrentUser = () => {
    return `${user.userInfo?.userId}` == data?.[activeTab]?.receiverId;
  };

  const cancelCallback = () => {
    loadData(props.detailData?.ptwDSeq);
  };

  const extendCallback = () => {
    loadData(props.detailData?.ptwDSeq);
  };

  const APPROVAL_SAVE_CATEGORIES = [
    'Area Authority',
    'PTW Coordinator',
    'SE&A PTW Coordinator(OPEN)',
    'SE&A PTW Coordinator'
  ];

  const currentApproverCategory = useMemo(() => {
    for (const tabKey of Object.keys(data)) {
      const approvalRow = (data[tabKey]?.approvalMVOList ?? []).find(
        (row: any) =>
          row?.approvalType === selectedApprovalType &&
          row?.approvalProcessSeq != null &&
          !row?.signType
      );
      if (approvalRow) return approvalRow.approverCategory as string;
    }
    return null;
  }, [data, selectedApprovalType]);

  const showApprovalSave =
    isApprovalMode && APPROVAL_SAVE_CATEGORIES.includes(currentApproverCategory ?? '');

  // 결재 전 저장 함수를 context ref에 등록 (렌더마다 최신 state를 바라보도록 직접 할당)
  saveBeforeApproval.current = showApprovalSave
    ? () => new Promise<boolean>((resolve) => save('S', true, resolve))
    : null;

  const hasOthersSigned = Object.values(data).some((tabData: any) =>
    (tabData?.approvalMVOList ?? []).some(
      (row: any) => !!row?.signType && row?.userId !== `${user.userInfo?.userId}`
    )
  );

  // const hasPerformingAuthoritySigned = Object.values(data).some((tabData: any) =>
  //   (tabData?.approvalMVOList ?? []).some(
  //     (row: any) => row?.approverCategory === 'Performing Authority' && !!row?.signType
  //   )
  // );

  const BUTTONS_BY_STATUS: Record<string, ButtonKey[]> = {
    draftLike: ['preview', 'applyOther', 'addSheet', 'draft', 'submit'],
    ongoing: showApprovalSave
      ? ['preview']
      : hasOthersSigned
        ? ['preview']
        : ['preview', 'withdraw'],
    approved: ['preview', 'cancel', 'extend', 'complete'],
    close: ['preview', 'recall'],
    denyOrCancel: ['preview', 'recall'],
    complete: ['submit'],
    extend: ['preview', 'applyOther', 'addSheet', 'draft', 'submit'],
    new: ['preview', 'applyOther', 'addSheet', 'draft', 'submit']
  };

  const complate = () => {
    const formData = new FormData();
    formData.append('ptwDSeq', mainPermitData.ptwDSeq);

    ptwApi.setApprovalProcessComplete(formData).then(async (r: any) => {
      if (r.isSuccess) {
        loadData(props.detailData?.ptwDSeq);
        setStatusUpdateDate(new Date());
        props.onActionCallback?.();
        commonMsg.alert(showAlarm, closeAlarm, 'Success', 'update success', () => {
          props.setIsModalOpen(false);
        });
      } else {
        commonMsg.alert(showAlarm, closeAlarm, 'Error', 'Error', null);
      }
    });
  };

  const getMainPermitData = () => {
    if (!data) return null;
    return Object.values(data).find((item: any) => item?.isMainPermit) ?? data?.[activeTab];
  };

  const getVisibleButtons = (): ButtonKey[] => {
    const base = getMainPermitData();
    if (!base) return [];
    if (base.isComplete || base.isNew) {
      return BUTTONS_BY_STATUS.complete;
    }

    if (base.approvalStatus == 'PENDING CLOSURE') {
      return BUTTONS_BY_STATUS.close;
    }

    if (base.approvalStatus === 'APPROVED') {
      return BUTTONS_BY_STATUS.approved;
    }

    if (base.approvalStatus === 'CLOSURE') {
      return BUTTONS_BY_STATUS.close;
    }

    if (base.approvalStatus === 'ONGOING') {
      return BUTTONS_BY_STATUS.ongoing;
    }

    if (base.approvalStatus === 'DENY' || base.approvalStatus === 'CANCEL') {
      return BUTTONS_BY_STATUS.denyOrCancel;
    }
    // draftLike 조건
    if (data?.status == null || data?.status == 'DRAFT') {
      return BUTTONS_BY_STATUS.draftLike;
    }
    return [];
  };
  const onAction = (action: string) => {
    setData((prev: any) => {
      const next = { ...prev };

      tabList.forEach((item: any) => {
        const key = item?.value;
        if (!key) return;

        const baseData = {
          ...next[key],
          [action === 'complete' ? 'isComplete' : 'isNew']: true
        };

        next[key] =
          action === 'complete'
            ? baseData
            : {
                ...baseData,
                refPtwDSeq: next[key].ptwDSeq,
                refPtwNo: next[key].ptwNo,
                ptwNo: null,
                ptwDSeq: null,
                newFileList: []
              };
      });

      return next;
    });

    getVisibleButtons();
  };

  const mainPermitData = getMainPermitData();

  const setNewData = (newType: string, saveType: string) => {
    setLoading(true);
    var clone = safObjectHelper.clone(data);

    const formData = new FormData();
    Object.entries(clone).forEach(([key, object]) => {
      if (object === null || object === undefined) return;
      Object.entries(object).forEach(([subKey, subObject]) => {
        if (subKey === 'fileList') {
          var fileList = subObject;
          for (var k in fileList) {
            const originalFile = fileList[k].file;
            if (originalFile) {
              const newFileName = fileList[k].fileId + '$$$' + originalFile.name;
              const modifiedFile = new File([originalFile], newFileName, {
                type: originalFile.type
              });
              formData.append('newFiles', modifiedFile);
            }
          }
        }
        const skipKeys = ['approvalMVOList', 'fileList', 'newFileList', 'iotDeviceList'];
        if (skipKeys.includes(subKey)) return;
        if (safObjectHelper.isJsonObject(subObject)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          object[subKey] = JSON.stringify(subObject);
        }
      });
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    var saveData = [];
    tabList.forEach((item: any, i: number) => {
      const obj = clone?.[item.value] ?? {};
      obj.formCode = item.value;
      obj.refPtwDSeq = newType == 'new' ? obj.ptwDSeq : null;
      obj.ptwDSeq = null;
      obj.ptwMSeq = null;
      obj.ptwNo = null;
      obj.isNew = newType == 'new';
      obj.isCopy = newType == 'copy';
      obj.extendCnt = 0;
      obj.subcontractor = null;
      //renew, revise, reuse 서버에서는 동일하게 작동
      saveData.push(obj);
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    clone.ptwPageDVOList = saveData;
    clone.saveType = saveType;
    //새로운 데이터로 복사
    clone.ptwMSeq = null;
    formData.append(
      `param`,
      new Blob([JSON.stringify(clone)], {
        type: 'application/json'
      })
    );

    ptwApi.setPtwIssue(formData).then(async (r) => {
      setLoading(false);
      if (!r.isSuccess) {
        commonMsg.alert(showAlarm, closeAlarm, 'Error', 'Error', null);
      } else {
        props.onActionCallback();
        commonMsg.alert(showAlarm, closeAlarm, 'Success', 'It has been Saved.', () => {});
        loadData(r.resultObject.ptwDSeq);
      }
    });
  };

  const renew = () => {
    setLoading(true);
    var clone = safObjectHelper.clone(data);
    const formData = new FormData();
    const skipKeys = ['approvalMVOList', 'fileList', 'newFileList', 'iotDeviceList'];
    const stringifyDvoFields = (dvo: any) => {
      Object.entries(dvo).forEach(([subKey, subObject]) => {
        if (skipKeys.includes(subKey)) return;
        if (safObjectHelper.isJsonObject(subObject)) {
          dvo[subKey] = JSON.stringify(subObject);
        }
      });
    };

    Object.entries(clone).forEach(([key, object]) => {
      if (object === null || object === undefined) return;
      if (Array.isArray(object)) {
        // ptwPageDVOList 등 배열 필드: 각 아이템의 중첩 객체를 stringify
        object.forEach((item: any) => {
          if (item && typeof item === 'object') stringifyDvoFields(item);
        });
      } else {
        Object.entries(object).forEach(([subKey, subObject]) => {
          if (subKey === 'newFileList') {
            var fileList = subObject;
            for (var k in fileList) {
              const originalFile = fileList[k].file;
              if (originalFile) {
                const newFileName = fileList[k].fileId + '$$$' + originalFile.name;
                const modifiedFile = new File([originalFile], newFileName, {
                  type: originalFile.type
                });
                formData.append('refNewFiles', modifiedFile);
              }
            }
          }
          if (skipKeys.includes(subKey)) return;
          if (safObjectHelper.isJsonObject(subObject)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            object[subKey] = JSON.stringify(subObject);
          }
        });
      }
    });

    const saveData: any[] = [];
    tabList.forEach((item: any) => {
      const obj = clone?.[item.value] ?? {};
      obj.formCode = item.value;
      obj.ptwDSeq = obj.refPtwDSeq;
      saveData.push(obj);
    });
    clone.ptwPageDVOList = saveData;

    clone.ptwDSeq = mainPermitData.refPtwDSeq;
    formData.append(
      `param`,
      new Blob([JSON.stringify(clone)], {
        type: 'application/json'
      })
    );
    ptwApi.renewIssue(formData).then(async (r) => {
      setLoading(false);
      if (!r.isSuccess) {
        commonMsg.alert(showAlarm, closeAlarm, 'Error', 'Error', null);
      } else {
        props.onActionCallback();
        commonMsg.alert(showAlarm, closeAlarm, 'Success', 'It has been Saved.', () => {});
        loadData(r.resultObject.ptwDSeq);
      }
    });
  };

  type ButtonItem = {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  };

  const BUTTONS = {
    preview: { label: 'Preview', onClick: () => setEnablePreview((prev) => !prev) },
    approvalSave: {
      label: 'Save',
      onClick: setApprovalSave
    },
    applyOther: { label: 'Apply Other', onClick: applyOther },
    addSheet: { label: 'Add Sheet', onClick: addSheet },
    print: { label: 'Print', onClick: () => handlePrint('A4') },
    printA3: { label: 'Print (A3)', onClick: () => handlePrint('A3') },
    // fileUpload: {
    //   label: 'File Upload',
    //   onClick: () => openFileUploader(),
    //   disabled: mainPermitData.isComplete ? true : false
    // },
    draft: {
      label: 'Save',
      onClick: () => {
        save('T');
      }
    },
    submit: {
      label: 'Submit',
      onClick: () => {
        if (mainPermitData.isComplete) {
          complate();
          return;
        } else if (mainPermitData.isNew) {
          const fileTargetCode: string[] = ['CW', 'HW', 'SW'];
          if (
            mainPermitData.newFileList.length == 0 &&
            mainPermitData.isNew &&
            fileTargetCode.includes(mainPermitData?.formCode)
          ) {
            commonMsg.alert(
              showAlarm,
              closeAlarm,
              'Warning',
              'Please attach the previous permit file ',
              null
            );
            return;
          }
          commonMsg.confirm(
            showAlarm,
            closeAlarm,
            'Confirm',
            'It is created with new data.',
            () => {
              renew();
            }
          );
          return;
        }
        save('S');
      }
    },
    cancel: { label: 'Cancel', onClick: onCancel, disabled: !isCurrentUser() },
    extend: {
      label: 'Extend',
      onClick: () => {
        setIsPermitExtendModal(true);
      }
    },
    complete: { label: 'Complete', onClick: () => onAction('complete') },
    renew: {
      label: 'Renew',
      onClick: () => {
        onAction('new');
        return;
      }
    },
    recall: {
      label: 'Recall',
      onClick: () => {
        commonMsg.confirm(showAlarm, closeAlarm, 'Confirm', 'It is created with new data.', () => {
          setNewData('copy', 'T');
        });
      }
    },
    withdraw: {
      label: 'Withdraw',
      onClick: () => {
        commonMsg.confirm(
          showAlarm,
          closeAlarm,
          'Confirm',
          'Are you sure you want to withdraw?',
          () => {
            ptwApi.withdrawIssue(mainPermitData.ptwMSeq).then((r) => {
              if (!r.isSuccess) {
                commonMsg.alert(showAlarm, closeAlarm, 'Error', 'Error', null);
              } else {
                commonMsg.alert(showAlarm, closeAlarm, 'Success', 'Withdrawn successfully.', () => {
                  props.onActionCallback();
                  props.setIsModalOpen(false);
                });
              }
            });
          }
        );
      }
    }
  } as const;

  type ButtonKey = keyof typeof BUTTONS;

  const onRefresh = () => {
    loadData(props.detailData?.ptwDSeq);
  };

  const handleSaveFiles = (files: UploadFile[]) => {
    setData((prev: any) => ({
      ...prev,
      [activeTab]: {
        ...prev[activeTab],
        fileList: files
      }
    }));
  };

  return (
    <>
      <BasicModalV2 open={props.isModalOpen} onClose={modalClose}>
        <CustomModalHeader title={props.title} modalClose={modalClose} />
        <div
          className={'custom-modal-body permit-issue-detail-modal'}
          style={{ width: enablePreview ? '1600px' : '1000px' }}
        >
          {getMainPermitData()?.ptwDSeq && (
            <>
              <PermitCancel
                setIsModalOpen={setIsPermitCancelModalOpen}
                isModalOpen={isPermitCancelModalOpen}
                onActionCallback={cancelCallback}
                title={'Permit Cancel'}
                ptwDSeq={getMainPermitData()!.ptwDSeq}
              />
              <PermitExtendModal
                setIsModalOpen={setIsPermitExtendModal}
                isModalOpen={isPermitExtendModal}
                onActionCallback={extendCallback}
                title={'Permit Extend'}
                ptwDSeq={getMainPermitData()!.ptwDSeq}
                validStartTime={getMainPermitData()!.validStartTime}
                validEndTime={getMainPermitData()!.validEndTime}
              />
            </>
          )}
          <FileUploaderModal
            setIsModalOpen={setIsFileUploaderModalOpen}
            isModalOpen={isFileUploaderModalOpen}
            onSaveFiles={handleSaveFiles}
            title={'File Upload'}
          />
          <div className={'saf-container'}>
            <div className={'saf-row'}>
              <div className={'saf-col'}>
                <div className={'contents-box'}>
                  <div className={'modal-top-button'}>
                    {enablePreview && (
                      <>
                        <TextButton
                          variant="outlined"
                          className={'btn-style-grey'}
                          onClick={() => handlePrint('A4')}
                        >
                          Print (A4)
                        </TextButton>
                        <TextButton
                          variant="outlined"
                          className={'btn-style-grey'}
                          onClick={() => handlePrint('A3')}
                        >
                          Print (A3)
                        </TextButton>
                      </>
                    )}

                    {getVisibleButtons()?.map((key) => {
                      const btn = BUTTONS[key] as ButtonItem;
                      return (
                        <TextButton
                          key={key}
                          variant="outlined"
                          className="btn-style-grey"
                          onClick={btn.onClick}
                          disabled={!!btn.disabled}
                        >
                          {btn.label}
                        </TextButton>
                      );
                    })}
                  </div>
                  <div
                    style={{
                      maxHeight: 'calc(100vh - 200px)',
                      minHeight: 'calc(100vh - 200px)',
                      overflowY: 'auto'
                    }}
                  >
                    <div className={'tab-box'}>
                      <CustomTab
                        tabList={tabList}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        isX={!mainPermitData?.approvalStatus ? true : false}
                        xAction={(item: any) => {
                          tabXAction(item);
                        }}
                        tabContents={
                          <>
                            {activeTab == 'CW' && (
                              <Form01ColdDetail
                                key={`${activeTab}_${data[activeTab]?.ptwDSeq}`}
                                data={data[activeTab]}
                                setData={setSubData(activeTab)}
                                handleChange={handleChange}
                                formCode={activeTab}
                                isReadOnly={!showApprovalSave && !!mainPermitData?.approvalStatus}
                                userInfo={user.userInfo}
                                onRefresh={onRefresh}
                                isFinish={props.detailData?.finish}
                              />
                            )}
                            {activeTab == 'HW' && (
                              <Form02HotDetail
                                key={`${activeTab}_${data[activeTab]?.ptwDSeq}`}
                                data={data[activeTab]}
                                setData={setSubData(activeTab)}
                                handleChange={handleChange}
                                formCode={activeTab}
                                isReadOnly={!showApprovalSave && !!mainPermitData?.approvalStatus}
                                userInfo={user.userInfo}
                                isFinish={props.detailData?.finish}
                              />
                            )}
                            {activeTab == 'SW' && (
                              <Form03SpaceDetail
                                key={`${activeTab}_${data[activeTab]?.ptwDSeq}`}
                                data={data[activeTab]}
                                setData={setSubData('SW')}
                                handleChange={handleChange}
                                formCode={'SW'}
                                isReadOnly={!showApprovalSave && !!mainPermitData?.approvalStatus}
                                userInfo={user.userInfo}
                                isFinish={props.detailData?.finish}
                              />
                            )}
                            {activeTab == 'RC' && (
                              <Form04RoadDetail
                                key={`${activeTab}_${data[activeTab]?.ptwDSeq}`}
                                data={data[activeTab]}
                                setData={setSubData('RC')}
                                handleChange={handleChange}
                                formCode={'RC'}
                                isReadOnly={!showApprovalSave && !!mainPermitData?.approvalStatus}
                                userInfo={user.userInfo}
                                isFinish={props.detailData?.finish}
                              />
                            )}
                            {activeTab == 'EC' && (
                              <Form06ExcavationDetail
                                key={`${activeTab}_${data[activeTab]?.ptwDSeq}`}
                                data={data[activeTab]}
                                setData={setSubData('EC')}
                                handleChange={handleChange}
                                formCode={'EC'}
                                isReadOnly={!showApprovalSave && !!mainPermitData?.approvalStatus}
                                isFinish={props.detailData?.finish}
                                mainPermitData={mainPermitData}
                              />
                            )}
                            {activeTab == 'LP' && (
                              <Form05LiftingDetail
                                key={`${activeTab}_${data[activeTab]?.ptwDSeq}`}
                                data={data[activeTab]}
                                setData={setSubData('LP')}
                                handleChange={handleChange}
                                formCode={'LP'}
                                isReadOnly={!showApprovalSave && !!mainPermitData?.approvalStatus}
                                userInfo={user.userInfo}
                                isFinish={props.detailData?.finish}
                                mainPermitData={mainPermitData}
                              />
                            )}
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  'preview-print-area preview-print-formcode-' +
                  activeTab?.toLowerCase() +
                  (printPaperSize === 'A3' ? ' print-page-a3' : '')
                }
                style={{ display: enablePreview ? 'flex' : 'none', width: '600px' }}
                ref={previewRef}
              >
                <PermitIssuePreview
                  formCode={activeTab}
                  itemData={data[activeTab]}
                  approvalStatus={mainPermitData?.approvalStatus}
                />
              </div>
            </div>
          </div>
        </div>
      </BasicModalV2>
    </>
  );
};

export default PermitIssueDetailModal;
